<template>
  <div>
    <SettingGroup>
      <SettingItem label="グループ呼出表示">
        <SelectBox
          :disabled="false"
          :options="selectboxOptions.groupCallDisplayType"
          :defaultValue="String(form.selectbox.groupCallDisplayType)"
          @update="val => (form.selectbox.groupCallDisplayType = val)"
        />
      </SettingItem>

      <SettingItem label="着信時動作の制限（グループ呼出）">
        <ToggleSwitch
          v-model="form.toggle.callAlertInhibit"
          :disable="false"
        />
      </SettingItem>

      <SettingItem label="再受信時の着信トーン制限">
        <ToggleSwitch
          v-model="form.toggle.alertToneRestrictionFrom2ndCall"
          :disable="false"
        />
      </SettingItem>

      <SettingItem label="ジッターバッファー">
        <SelectBox
          :disabled="false"
          :options="selectboxOptions.jitterBuffer"
          :defaultValue="String(form.selectbox.jitterBuffer)"
          @update="val => (form.selectbox.jitterBuffer = val)"
        />
      </SettingItem>
    </SettingGroup>

    <SettingGroup title="着信トーン/LED">
        <SettingItem label="個別呼出">
            <ToggleSwitch
              v-model="form.toggle.alertToneLed.individualCallAlertTone"
              label="着信トーン"
              :disable="false"
            />
            <ToggleSwitch
                v-model="form.toggle.alertToneLed.individualCallLed"
                label="着信 LED"
                :disable="false"
            />
        </SettingItem>
        <SettingItem label="グループ呼出">
            <ToggleSwitch
                v-model="form.toggle.alertToneLed.groupCallAlertTone"
                label="着信トーン"
                :disable="false"
            />
            <ToggleSwitch
                v-model="form.toggle.alertToneLed.groupCallLed"
                label="着信 LED"
                :disable="false"
            />
        </SettingItem>
        <SettingItem label="メッセージ着信">
            <ToggleSwitch
                v-model="form.toggle.alertToneLed.messageAlertTone"
                label="着信トーン"
                :disable="false"
            />
        </SettingItem>
        <SettingItem label="エマージェンシー着信（開始/終了）">
            <ToggleSwitch
              v-model="form.toggle.alertToneLed.emergencyAlertTone"
              label="着信トーン"
              :disable="false"
            />
        </SettingItem>
    </SettingGroup>

    <SettingGroup title="受信モード解除">
      <SettingItem label="受信モード解除時間">
        <ToggleSwitch
          v-model="form.toggle.autoReset.autoResetTimer"
          :disable="false"
        />
        <RangeSlider
          :inputValue="form.range.autoReset.autoResetTimerValue"
          :disable="!form.toggle.autoReset.autoResetTimer"
          :minLimit="BC.SEL_CALL.GENERAL.AUTO_RESET.AUTO_RESET_TIMER_VALUE.MIN"
          :maxLimit="BC.SEL_CALL.GENERAL.AUTO_RESET.AUTO_RESET_TIMER_VALUE.MAX"
          unit="[秒]"
          @update:inputValue="val => form.range.autoReset.autoResetTimerValue = val"
        />
      </SettingItem>
      <SettingItem label="LCD">
        <ToggleSwitch
          v-model="form.toggle.autoReset.lcd"
          :disable="false"
        />
      </SettingItem>
      <SettingItem label="LED">
        <ToggleSwitch
          v-model="form.toggle.autoReset.led"
          :disable="false"
        />
      </SettingItem>
      <SettingItem label="着信トーン">
        <ToggleSwitch
          v-model="form.toggle.autoReset.alertTone"
          :disable="false"
        />
      </SettingItem>
    </SettingGroup>
  </div>
</template>

<script>
import RangeSlider from '@/components/pc/radio/ipradio/atoms/RangeSlider.vue'
import SelectBox from '@/components/pc/radio/ipradio/atoms/SelectBox.vue'
import ToggleSwitch from '@/components/pc/radio/ipradio/atoms/ToggleSwitch.vue'
import SettingGroup from '@/components/pc/radio/ipradio/organisms/layout/SettingGroup.vue'
import SettingItem from '@/components/pc/radio/ipradio/organisms/layout/SettingItem.vue'
import { BC, BC_TRANS_JP } from '@/components/pc/radio/ipradio/config/BCconstants'
import { useRadioSettingsStore } from '@/components/pc/radio/ipradio/stores/bcRadioSettings'
import { mapStores } from 'pinia'

export default {
  name: 'SelCallGeneralVue2',
  components: {
    RangeSlider, SelectBox, ToggleSwitch, SettingGroup, SettingItem,
  },
  data () {
    const selectboxOptions = {
      groupCallDisplayType: Object.keys(BC_TRANS_JP.SEL_CALL.GENERAL.GROUP_CALL_DISPLAY_TYPE).map(
        key => ({
          label: BC_TRANS_JP.SEL_CALL.GENERAL.GROUP_CALL_DISPLAY_TYPE[key],
          value: BC.SEL_CALL.GENERAL.GROUP_CALL_DISPLAY_TYPE[key],
        })
      ),
      jitterBuffer: Object.entries(BC.SEL_CALL.GENERAL.JITTER_BUFFER).flatMap(([key, val]) => {
        if (Array.isArray(val)) {
          return val.map(v => ({ label: v, value: v }))
        } else {
          return { label: BC_TRANS_JP.SEL_CALL.GENERAL.JITTER_BUFFER[key], value: val }
        }
      }),
    }

    return {
      selectboxOptions,
      form: {
        selectbox: {
          groupCallDisplayType: selectboxOptions.groupCallDisplayType[0].value,
          jitterBuffer: selectboxOptions.jitterBuffer[0].value,
        },
        toggle: {
          callAlertInhibit: false,
          alertToneRestrictionFrom2ndCall: false,
          alertToneLed: {
              individualCallAlertTone: false,
              individualCallLed: false,
              groupCallAlertTone: false,
              groupCallLed: false,
              messageAlertTone: false,
              emergencyAlertTone: false
          },
          autoReset: { autoResetTimer: false, lcd: false, led: false, alertTone: false },
        },
        range: {
          autoReset: {
            autoResetTimerValue: BC.SEL_CALL.GENERAL.AUTO_RESET.AUTO_RESET_TIMER_VALUE.MIN,
          },
        },
      },
      setting: null, // ストアの一時設定参照
    }
  },
  computed: {
    BC() {
      return BC
    },
    ...mapStores(useRadioSettingsStore),
  },
  created () {
    // ストアから設定を取得
    this.setting = this.radioSettingsStore.getTempSetting()

    // 設定 → フォームへ反映
    this.transSetting2Form()

    // フォーム変更を監視：設定へ反映 & 保存
    this.$watch('form', () => {
      this.transForm2Setting()
      this.radioSettingsStore.saveTempSetting(this.setting)
    }, { deep: true })
  },
  methods: {
    // 設定 ← フォーム
    transForm2Setting () {
      const data = this.setting?.SelCall?.General
      if (!data) return

      data.GroupCallDisplayType = this.form.selectbox.groupCallDisplayType

      data.CallAlertInhibit =
        this.form.toggle.callAlertInhibit ? BC.COMMON.TOGGLE.ENABLE : BC.COMMON.TOGGLE.DISABLE

      data.AlertToneRestrictionFrom2ndCall =
        this.form.toggle.alertToneRestrictionFrom2ndCall
          ? BC.COMMON.TOGGLE.ENABLE
          : BC.COMMON.TOGGLE.DISABLE

      data.JitterBuffer = this.form.selectbox.jitterBuffer

      data.AlertTone_LED.IndividualCallAlertTone =
          this.form.toggle.alertToneLed.individualCallAlertTone ? BC.COMMON.TOGGLE.ENABLE : BC.COMMON.TOGGLE.DISABLE
      data.AlertTone_LED.IndividualCallLED =
          this.form.toggle.alertToneLed.individualCallLed ? BC.COMMON.TOGGLE.ENABLE : BC.COMMON.TOGGLE.DISABLE

      data.AlertTone_LED.GroupCallAlertTone =
          this.form.toggle.alertToneLed.groupCallAlertTone ? BC.COMMON.TOGGLE.ENABLE : BC.COMMON.TOGGLE.DISABLE
      data.AlertTone_LED.GroupCallLED =
          this.form.toggle.alertToneLed.groupCallLed ? BC.COMMON.TOGGLE.ENABLE : BC.COMMON.TOGGLE.DISABLE

      data.AlertTone_LED.MessageAlertTone =
            this.form.toggle.alertToneLed.messageAlertTone ? BC.COMMON.TOGGLE.ENABLE : BC.COMMON.TOGGLE.DISABLE

        data.AlertTone_LED.EmergencyAlertTone =
          this.form.toggle.alertToneLed.emergencyAlertTone ? BC.COMMON.TOGGLE.ENABLE : BC.COMMON.TOGGLE.DISABLE

      data.AutoReset.AutoResetTimer =
        this.form.toggle.autoReset.autoResetTimer ? BC.COMMON.TOGGLE.ENABLE : BC.COMMON.TOGGLE.DISABLE

      data.AutoReset.AutoResetTimerValue = this.form.range.autoReset.autoResetTimerValue

      data.AutoReset.LCD =
        this.form.toggle.autoReset.lcd ? BC.COMMON.TOGGLE.ENABLE : BC.COMMON.TOGGLE.DISABLE

      data.AutoReset.LED =
        this.form.toggle.autoReset.led ? BC.COMMON.TOGGLE.ENABLE : BC.COMMON.TOGGLE.DISABLE

      data.AutoReset.AlertTone =
        this.form.toggle.autoReset.alertTone ? BC.COMMON.TOGGLE.ENABLE : BC.COMMON.TOGGLE.DISABLE
    },

    // 設定 → フォーム
    transSetting2Form () {
      const data = this.setting?.SelCall?.General
      if (!data) return

      this.form.selectbox.groupCallDisplayType = data.GroupCallDisplayType
      this.form.toggle.callAlertInhibit = data.CallAlertInhibit === BC.COMMON.TOGGLE.ENABLE
      this.form.toggle.alertToneRestrictionFrom2ndCall =
        data.AlertToneRestrictionFrom2ndCall === BC.COMMON.TOGGLE.ENABLE
      this.form.selectbox.jitterBuffer = data.JitterBuffer

        this.form.toggle.alertToneLed.individualCallAlertTone =
            data.AlertTone_LED.IndividualCallAlertTone === BC.COMMON.TOGGLE.ENABLE
        this.form.toggle.alertToneLed.individualCallLed =
            data.AlertTone_LED.IndividualCallLED === BC.COMMON.TOGGLE.ENABLE

        this.form.toggle.alertToneLed.groupCallAlertTone =
            data.AlertTone_LED.GroupCallAlertTone === BC.COMMON.TOGGLE.ENABLE
        this.form.toggle.alertToneLed.groupCallLed =
            data.AlertTone_LED.GroupCallLED === BC.COMMON.TOGGLE.ENABLE

        this.form.toggle.alertToneLed.messageAlertTone =
            data.AlertTone_LED.MessageAlertTone === BC.COMMON.TOGGLE.ENABLE

        this.form.toggle.alertToneLed.emergencyAlertTone =
            data.AlertTone_LED.EmergencyAlertTone === BC.COMMON.TOGGLE.ENABLE

      this.form.toggle.autoReset.autoResetTimer =
        data.AutoReset.AutoResetTimer === BC.COMMON.TOGGLE.ENABLE

      this.form.range.autoReset.autoResetTimerValue = data.AutoReset.AutoResetTimerValue

      this.form.toggle.autoReset.lcd = data.AutoReset.LCD === BC.COMMON.TOGGLE.ENABLE
      this.form.toggle.autoReset.led = data.AutoReset.LED === BC.COMMON.TOGGLE.ENABLE
      this.form.toggle.autoReset.alertTone = data.AutoReset.AlertTone === BC.COMMON.TOGGLE.ENABLE
    },
  },
}
</script>

<style scoped>
::v-deep .label {
  width: 280px;
}
</style>
